module.exports = __webpack_public_path__ + "media/images/metruyenchu-logo-c0f6192077ebc0ed8c6fedf48dc60048.png";